<template lang="pug">
with-actions(
  v-on="$listeners"
)
  .list.text-body-1
    p Добавьте #[a(href="/settings/addresses" target="_blank").link Адреса проведения]
    p Добавьте задания в разделе #[a(href="/polls" target="_blank").link "Задания и кимы"]
    p Ознакомьтесь с #[a(href="/instructions" target="_blank").link Инструкциями]
</template>

<script>
import WithActions from '../components/WithActions.vue';

export default {
  name: 'OrganizationWelcome',
  components: {
    WithActions,
  },
  props: {},
  data() {
    return {};
  },
  computed: {},
  watch: {},
  created() {},
  methods: {},
};
</script>
